import sanitizeHtml from "sanitize-html";
import { dateFormat } from "../../const/date";

type BlogData = {
  data: {
    category: Array<string>;
    title: Array<string>;
    link: Array<string>;
    description: Array<string>;
    pubDate: Array<string>;
  }[];
};

const Blog = ({ data }: { data: BlogData[] | any[] }) => {
  const blog = ParseData({ data });

  const getTranslated = (key: string) => {
    const text = key || ""; //data json에서 호출
    const sanitizedText = sanitizeHtml(text, {
      allowedTags: ["br", "em", "span"], //허용할 태그 지정
    });
    return { __html: sanitizedText };
  };
  return (
    <div
      id="blog"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-3.5 lg:py-7 bg-primary"
    >
      <div className=" relative w-full h-full grid lg:grid-cols-5 gap-5">
        <div className="lg:col-span-3 relative w-full h-full">
          <img src="/images/blog1.png" alt="싹치워드림 유품정리 작업사례 네이버 블로그" />
        </div>
        <div className="lg:col-span-2 relative w-full h-full grid grid-rows-4 gap-3 py-10 3xl:py-20">
          {blog.map((v, i) => (
            <div
              key={i}
              data-aos="fade-up"
              onClick={() => window.open(v.link[0])}
              className={
                i > 7
                  ? "hidden lg:block relative w-full h-full"
                  : "relative w-full h-full"
              }
            >
              <div className="relative w-full h-full grid bg-white p-2 md:p-3 rounded-3xl text-left border cursor-pointer transition-all duration-300 overflow-hidden">
                <p
                  className={`relative w-full whitespace-nowrap overflow-hidden overflow-ellipsis lg:text-lg h-fit mb-1`}
                >
                  {v.title[0]}
                </p>
                <small
                  className={`relative w-full whitespace-nowrap overflow-hidden overflow-ellipsis h-fit mb-1 text-sm opacity-60`}
                  dangerouslySetInnerHTML={getTranslated(v.description[0])}
                  // dangerouslySetInnerHTML={{ __html: v.description[0] }}
                ></small>
                <div className="md:pt-1.5 lg:flex justify-between items-end">
                  <small className="hidden xl:block opacity-40 lg:text-sm">
                    {dateFormat(v.pubDate[0])}
                  </small>
                  <small className="text-main lg:text-sm">
                    {v.category[0]}
                  </small>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const parseString = require("xml2js").parseString;

const ParseData = ({ data }: { data: any[] }) => {
  const dataArr: {
    title: any;
    link: any;
    description: any;
    pubDate: any;
    category: any;
  }[] = [];

  parseString(data, (err: any, result: any) => {
    if (err) {
      console.error("XML 파싱 에러:", err);
      return;
    }

    const items = result?.rss?.channel?.[0]?.item;
    if (Array.isArray(items)) {
      items.slice(0, 4).forEach((v: any) => {
        dataArr.push({
          title: v.title,
          link: v.link,
          description: v.description,
          pubDate: v.pubDate,
          category: v.category,
        });
      });
    } else {
      console.warn("item 배열이 없습니다.");
    }
  });

  return dataArr;
};

export default Blog;
